import { Observable, Subscription } from 'rxjs';
import { Component, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { completedReason } from '@shared/constants/completed-reason';
import { pauseReason } from '@shared/constants/pause-reason';
import { statusTypes } from '@shared/constants/status-types';
import { DevicePublisherService } from '@shared/services/publishers/device-publisher.service';
import { BusyStatusReason, PrintingStatusReason } from '@shared/constants/status-reason';

@Component({
  selector: 'app-device-status-name',
  templateUrl: './device-status-name.component.html',
  styleUrls: ['./device-status-name.component.scss']
})
export class DeviceStatusNameComponent implements AfterViewInit, OnDestroy {
  statusTypes = statusTypes;
  pauseReason = pauseReason;
  printingReason = PrintingStatusReason;
  busyReason = BusyStatusReason;
  private _completedReason = completedReason;
  public get completedReason() {
    return this._completedReason;
  }
  public set completedReason(value) {
    this._completedReason = value;
  }
  heatingProgressObservable$ !: Observable<number>;
  subscription = new Subscription();

  @Input() deviceId!: string;
  @Input() statusCode!: number;
  @Input() reason?: number;
  @Input() heatingProgress?: number;

  constructor(private devicePublisherService: DevicePublisherService) { }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.subscription.add(this.devicePublisherService.getDeviceHeatingProgressObservable(this.deviceId).subscribe(res =>{
      this.heatingProgress = res;
    }));

    this.subscription.add(this.devicePublisherService.getDeviceParsingProgressObservable(this.deviceId).subscribe(res =>{
      this.heatingProgress = res.progress;
    }));
  }
}
